import { motion } from "framer-motion";

const LINKS = [
  { href: "#muziek", label: "Muziek", testid: "nav-link-muziek" },
  { href: "#verhalen", label: "Verhalen", testid: "nav-link-verhalen" },
  { href: "#over", label: "Over", testid: "nav-link-over" },
  { href: "#contact", label: "Contact", testid: "nav-link-contact" },
];

export const Navbar = () => (
  <motion.header
    initial={{ y: -48, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
    className="fixed top-0 inset-x-0 z-40 bg-sand-50/85 backdrop-blur-md border-b border-sand-200/70"
  >
    <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
      <a href="#top" data-testid="nav-wordmark" className="font-serif italic text-2xl tracking-widest text-sand-900">
        Frank en Vrij
      </a>
      <nav className="hidden sm:flex items-center gap-8">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testid}
            className="relative font-sans text-xs font-light tracking-[0.2em] uppercase text-sand-900/70 transition-colors duration-300 hover:text-terracotta-500 after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-terracotta-500 after:transition-[width] after:duration-300 hover:after:w-full"
          >
            {l.label}
          </a>
        ))}
      </nav>
    </div>
  </motion.header>
);
